import * as React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { About } from "../components/about"
import { Contact } from "../components/contact"
import { Hero } from "../components/hero"
import { Education } from "../components/education"
import { Projects } from "../components/projects"
import "./index.css"
import {Skills} from "../components/skills"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <Hero />
    <About />
    <Education />
    <Skills/>
    <Projects/>
    <Contact />
  </Layout>
)

export default IndexPage
